import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TypedNgbModal } from '@assetaccountant/core/utils/typed-modal';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-view-pricing-modal',
  templateUrl: './view-pricing-modal.component.html',
  styleUrls: ['./view-pricing-modal.component.scss'],
  standalone: false,
})
export class ViewPricingModalComponent {
  @Input() destinationRouteCommand: string;
  @Input() newOrganisation: boolean;

  @Output() packageUpdated = new EventEmitter();

  isUpdating = false;

  constructor(
    public modal: NgbActiveModal,
    private router: Router,
    @Inject(NgbModal) public ngbModal: TypedNgbModal,
  ) {}

  close() {
    if (this.destinationRouteCommand) {
      this.router.navigateByUrl(this.destinationRouteCommand);
    }
    this.modal.close();
  }

  onPackageUpdated() {
    this.packageUpdated.emit();

    if (this.destinationRouteCommand) {
      this.router.navigateByUrl(this.destinationRouteCommand);
    }

    this.modal.close();
  }
}
